var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkingManagementIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1757_1271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2214 18.4557C10.2214 18.4557 16.888 13.4557 16.888 8.03906C16.888 4.5874 13.9034 1.78906 10.2214 1.78906C6.53927 1.78906 3.55469 4.5874 3.55469 8.03906C3.55469 13.4557 10.2214 18.4557 10.2214 18.4557Z",
    stroke: "#9C4900",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96875 5.95312V12.6198",
    stroke: "#9C4900",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96875 5.95312H11.4687C11.9108 5.95313 12.3347 6.12872 12.6473 6.44128C12.9598 6.75384 13.1354 7.17776 13.1354 7.61979C13.1354 8.06182 12.9598 8.48574 12.6473 8.7983C12.3347 9.11086 11.9108 9.28646 11.4687 9.28646H8.96875V5.95312Z",
    stroke: "#8F4300",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1757_1271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.21875 0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingManagementIconActive);
export default __webpack_public_path__ + "static/media/ParkingManagement_icon_active.0fd2f55b105c8ad037021d2ec11fa911.svg";
export { ForwardRef as ReactComponent };